import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="composition-row"
export default class extends Controller {
  static targets = [
    // helperPrice depends on buyingPrice & margin
    "name",
    "buyingPrice",
    "margin",
    "helperPrice",
    // boxItemPrice depends on sellingPrice and quantity
    "sellingPrice",
    "quantity",
  ];

  static outlets = ["composition"];

  connect() {
    this.parent = this.#getCompositionOutlet();
    if (this.parent?.margin) {
      this.updateMargin(this.parent.margin);
    }
  }

  updateHelperPrice() {
    const buyingPrice = this.buyingPriceTarget.value;
    const margin = this.marginTarget.value;

    if (buyingPrice && margin) {
      const helperPrice = (
        parseFloat(buyingPrice) /
        (1 - parseFloat(margin) / 100.0)
      ).toFixed(2);

      this.helperPriceTarget.value = helperPrice;

      if (!this.sellingPriceTarget.value) {
        this.sellingPriceTarget.value = helperPrice;
      }
    }
  }

  updateBoxItemPrice() {
    const sellingPrice = this.sellingPriceTarget.value;

    if (sellingPrice) {
      this.quantityTargets.forEach((target) => {
        const quantity = target.value;

        const output = target
          .closest("td")
          .nextElementSibling.querySelector("output");

        if (quantity && output) {
          output.value = (
            parseFloat(sellingPrice) * parseFloat(quantity)
          ).toFixed(2);

          this.parent.updateTotal(target.dataset.boxId);
        }
      });
    }
  }

  updateMargin(margin) {
    this.marginTarget.value = margin;
  }

  copyName(event) {
    this.nameTarget.value ||= event.target.selectedOptions[0]?.textContent;
  }

  #getCompositionOutlet() {
    return this.compositionOutlets.find(
      (outlet) =>
        outlet.element ===
        this.element.closest("[data-controller~='composition']"),
    );
  }
}
